function buildAttentionPointHandoffAction(alert, action) {
  if (!alert || !action || !action.capabilityKey) return null

  var object = alert.object || {}
  var targetCapability = String(action.capabilityKey).toUpperCase()
  var label = action.label || 'Traiter le point d’attention'
  var ruleKey = alert.explanation && alert.explanation.ruleKey || alert.ruleType || null
  var alertContext = {
    alertId: alert.id,
    ruleKey: ruleKey,
    object: object,
    evidence: Array.isArray(alert.evidence) ? alert.evidence : [],
    actionKey: action.key || null,
    actionContext: action.context && typeof action.context === 'object' ? action.context : {}
  }

  return {
    label: label,
    targetCapability: targetCapability,
    displayLabel: resolveAttentionCapabilityLabel(targetCapability),
    reason: alert.justification || '',
    icon: action.icon || 'bot',
    requestContext: {
      currentRecord: {
        objectType: object.type,
        recordId: object.id,
        label: object.label || null
      },
      alertAction: {
        alertId: alert.id,
        actionKey: action.key || null,
        ruleKey: ruleKey,
        targetCapability: targetCapability
      },
      capabilitySuggestion: {
        originCapability: 'ALERTS',
        originStep: ruleKey,
        targetCapability: targetCapability,
        label: label,
        reason: alert.justification || '',
        displayLabel: resolveAttentionCapabilityLabel(targetCapability),
        icon: action.icon || 'bot',
        originContext: alertContext
      }
    }
  }
}

function resolveAttentionCapabilityLabel(capabilityKey) {
  var labels = {
    WRITE_EMAIL: '@Plume',
    BRIEFING: '@Briefing',
    DEBRIEF: '@Debrief',
    DICTATION: '@Dictée',
    SUMMARIZE: '@Synthèse',
    RADAR: '@Radar'
  }
  return labels[String(capabilityKey || '').toUpperCase()] || '@' + String(capabilityKey || 'Cap')
}

export { buildAttentionPointHandoffAction }
